import { FinancialBrand } from "@dreambigger/shared/src/types";
import animations from "@dreambigger/shared/src/components/board/styles/animations.module.scss";

interface StepContentHeaderProps {
  brand: FinancialBrand;
  title: string;
  description: string;
}

const StepContentHeader = ({
  brand,
  title,
  description,
}: StepContentHeaderProps) => {
  return (
    <>
      {/* Step Title */}
      <h1
        className={`f-7 sm_f-8 fwt lh-1 mb-4 ${animations.fadeIn_m}`}
        style={{
          color: brand.stepTitleColor || brand.primaryColor,
        }}
        dangerouslySetInnerHTML={{
          __html: title ?? "",
        }}
      />

      {/* Step Description */}
      <p
        className={`f-4 gray-8 mb-5 lh-3 ${animations.fadeIn_s}`}
        dangerouslySetInnerHTML={{
          __html: description ?? "",
        }}
      />
    </>
  );
};

export default StepContentHeader;
